export const isEnumMember = <T extends { [key: string]: unknown }>(
  enumToCheck: T,
  maybeMember: unknown
): maybeMember is T[keyof T] => Object.values(enumToCheck).includes(maybeMember);
